/**
 * Chiude il drawer "Messaggi" quando l'utente cambia pagina (es. "Apri scheda"
 * del Lead/Cliente, "Apri offerta"): prima la pagina nuova restava coperta.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { shouldCloseOnRouteChange } from './drawerLayout';

export function useCloseDrawerOnRouteChange(isOpen: boolean, close: () => void) {
  const { pathname } = useLocation();
  const prevPath = useRef<string | null>(null);
  const openedAt = useRef<number>(0);

  useEffect(() => {
    if (isOpen) openedAt.current = Date.now();
  }, [isOpen]);

  useEffect(() => {
    const prev = prevPath.current;
    prevPath.current = pathname;
    if (shouldCloseOnRouteChange({ prevPath: prev, nextPath: pathname, isOpen, msSinceOpen: Date.now() - openedAt.current })) {
      close();
    }
    // isOpen volutamente fuori dalle dipendenze: conta solo il cambio pagina.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
